import React from 'react';
import { StepProps, SPECIALTY_COLORS } from '../../types';
import { motion } from 'framer-motion';
import { ArrowRight, GitMerge } from 'lucide-react';
export function SystemGap({
  nextStep
}: StepProps) {
  return <div className="flex-grow flex flex-col py-12 px-6 overflow-y-auto" data-id="element-480">
      <div className="max-w-4xl w-full mx-auto" data-id="element-481">
        <div className="text-center mb-12" data-id="element-482">
          <h2 className="text-3xl md:text-5xl font-bold text-dark mb-6" data-id="element-483">
            The System Gap
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-484">
            This isn't individual failure — it's system misalignment.
          </p>
          <p className="text-lg text-brand font-medium mt-4" data-id="element-485">
            For Bayer teams, understanding these gaps is critical to effective
            engagement.
          </p>
        </div>

        <div className="bg-gray-50 rounded-3xl p-8 md:p-12 border border-gray-200 mb-12 relative overflow-hidden" data-id="element-486">
          {/* Abstract connection lines background */}
          <svg className="absolute inset-0 w-full h-full opacity-10" preserveAspectRatio="none" data-id="element-487">
            <path d="M0,50 Q200,150 400,50 T800,50" stroke="black" strokeWidth="2" fill="none" data-id="element-488" />
            <path d="M0,150 Q200,50 400,150 T800,150" stroke="black" strokeWidth="2" fill="none" data-id="element-489" />
          </svg>

          <div className="relative z-10 text-center" data-id="element-490">
            <div className="inline-flex items-center justify-center p-4 bg-white rounded-full shadow-md mb-8" data-id="element-491">
              <GitMerge size={40} className="text-brand" data-id="element-492" />
            </div>

            <h3 className="text-2xl md:text-4xl font-bold text-dark mb-8 leading-tight" data-id="element-493">
              Differences between specialties contribute to delayed optimal
              treatment in up to{' '}
              <span className="text-brand" data-id="element-494">~50% of cases</span>.
            </h3>

            <div className="flex flex-wrap justify-center gap-4 md:gap-8 mt-12" data-id="element-495">
              <div className="flex flex-col items-center" data-id="element-496">
                <div className="w-16 h-16 rounded-full flex items-center justify-center text-white font-bold text-xl mb-2 shadow-lg" style={{
                backgroundColor: SPECIALTY_COLORS.PCP
              }} data-id="element-497">
                  PCP
                </div>
                <span className="text-sm text-gray-500 font-medium uppercase" data-id="element-498">
                  Early/Conservative
                </span>
              </div>
              <div className="flex flex-col items-center justify-center" data-id="element-499">
                <div className="w-8 h-1 bg-gray-300 rounded-full" data-id="element-500"></div>
              </div>
              <div className="flex flex-col items-center" data-id="element-501">
                <div className="w-16 h-16 rounded-full flex items-center justify-center text-white font-bold text-xl mb-2 shadow-lg" style={{
                backgroundColor: SPECIALTY_COLORS.Endocrinologist
              }} data-id="element-502">
                  Endo
                </div>
                <span className="text-sm text-gray-500 font-medium uppercase" data-id="element-503">
                  Metabolic Focus
                </span>
              </div>
              <div className="flex flex-col items-center justify-center" data-id="element-504">
                <div className="w-8 h-1 bg-gray-300 rounded-full" data-id="element-505"></div>
              </div>
              <div className="flex flex-col items-center" data-id="element-506">
                <div className="w-16 h-16 rounded-full flex items-center justify-center text-white font-bold text-xl mb-2 shadow-lg" style={{
                backgroundColor: SPECIALTY_COLORS.Cardiologist
              }} data-id="element-507">
                  Cardio
                </div>
                <span className="text-sm text-gray-500 font-medium uppercase" data-id="element-508">
                  Proactive/CV
                </span>
              </div>
              <div className="flex flex-col items-center justify-center" data-id="element-509">
                <div className="w-8 h-1 bg-gray-300 rounded-full" data-id="element-510"></div>
              </div>
              <div className="flex flex-col items-center" data-id="element-511">
                <div className="w-16 h-16 rounded-full flex items-center justify-center text-white font-bold text-xl mb-2 shadow-lg" style={{
                backgroundColor: SPECIALTY_COLORS.Nephrologist
              }} data-id="element-512">
                  Neph
                </div>
                <span className="text-sm text-gray-500 font-medium uppercase" data-id="element-513">
                  Late/Reactive
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="flex justify-center pb-8" data-id="element-514">
          <button onClick={nextStep} className="inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-white bg-dark rounded-full hover:bg-black transition-colors" data-id="element-515">
            See the Consequences
            <ArrowRight className="ml-2 w-5 h-5" data-id="element-516" />
          </button>
        </div>
      </div>
    </div>;
}